/**
 * @desc 导出物流订单--补料信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(tmsNo: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/exportBlPod/${tmsNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
